var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatar = function SvgDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#E5E7F0",
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29.782 17.512a2.989 2.989 0 1 1-5.978 0 2.989 2.989 0 0 1 5.978 0m-9.284 9.415a2.988 2.988 0 1 1-5.977-.001 2.988 2.988 0 0 1 5.977 0m-3.02 9.574v6.082c13.81 0 25.042-11.235 25.042-25.044h-6.08c0 10.456-8.507 18.962-18.962 18.962",
    clipRule: "evenodd"
  })));
};
export default SvgDefaultAvatar;